var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_38858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5H36V7.5H0V28.5ZM34.8746 27.45H1.12544V8.55H34.8886L34.8746 27.45Z",
    fill: "#171C22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6154 13.196C14.075 12.6185 12.3657 12.5857 10.7971 13.0976C9.93196 13.3601 9.20746 13.9245 8.77839 14.6792C8.40558 15.447 8.48999 16.3395 8.99644 17.0351C9.36221 17.5404 9.88976 17.9276 10.5017 18.1507C11.8311 18.5707 13.1957 18.866 14.5885 19.0367C14.9331 19.0892 15.2426 19.2467 15.4818 19.4829C15.6647 19.6732 15.742 19.9226 15.7069 20.172C15.6436 20.5854 15.3833 20.9463 15.0035 21.1629C14.5885 21.3729 14.1172 21.4779 13.6459 21.4582C12.9566 21.5107 12.2672 21.3663 11.6694 21.0448C11.3528 20.8413 11.0926 20.5657 10.9238 20.2376C10.8182 20.0013 10.7338 19.7585 10.6565 19.5157L8.54626 19.6863C8.5955 20.2113 8.73618 20.7298 8.9683 21.2154C9.14415 21.5304 9.35517 21.8257 9.5873 22.1013C9.9601 22.4688 10.4243 22.7445 10.9449 22.8954C11.4724 23.066 12.0211 23.1645 12.5767 23.1907C13.1395 23.2563 13.7022 23.2563 14.2649 23.1907C14.8206 23.1251 15.3622 23.0135 15.8968 22.8626C16.4173 22.6592 16.8745 22.3442 17.2333 21.9373C17.4513 21.6354 17.6272 21.3073 17.7538 20.9595C17.8804 20.5526 17.9085 20.1195 17.8452 19.6995C17.81 19.3188 17.7045 18.9513 17.5287 18.6101C17.1277 17.9538 16.4454 17.4945 15.6506 17.3435C14.5603 17.186 13.4841 16.9498 12.429 16.6413C12.0562 16.556 11.6975 16.4117 11.3739 16.2213C11.1981 16.1032 11.0926 15.9063 11.0996 15.7029C11.1066 15.4995 11.184 15.3092 11.3106 15.1451C11.5568 14.8563 11.9015 14.6529 12.2884 14.5742C12.5838 14.5085 12.8792 14.4626 13.1817 14.4495C13.5334 14.4757 13.878 14.5348 14.2157 14.6135C14.5322 14.666 14.8136 14.8301 15.0035 15.0729C15.2145 15.342 15.3692 15.6438 15.4748 15.9654L17.585 15.8735C17.5216 14.7054 16.762 13.6685 15.6154 13.196Z",
    fill: "#171C22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1888 12.75V18.7481L21.8195 12.75H19.5686V23.2434H21.8195V17.265L25.1888 23.2434H27.4396V12.75H25.1888Z",
    fill: "#171C22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_38858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSn);
export default __webpack_public_path__ + "static/media/sn.06aa554cc88f827c759ac37b701e494b.svg";
export { ForwardRef as ReactComponent };